/****** choose diamond function ********/
$(document).on("click", ".chooseDiamondLink", function() {
    $('#choose_diamond').addClass('choose_diamond_spinner');

    var diamond_id = $(this).data("diamondid");

    var productSku = []; 
    var proceedFlag = 1;
    jQuery.getJSON('/cart.js', function(cart) {
      if(cart.items != ''){ 
        
        $(cart.items).each(function(index, value) { 
           var str = "-";   
           var sku = value.sku;
  
           if(sku.indexOf(str) != -1){                  
             sku = sku.split('-');
             sku = sku[1];                       
           }else{
             var sku = value.sku;      
           }
                     
           if(sku == diamond_id){
             $('#choose_diamond').removeClass('choose_diamond_spinner');
             proceedFlag = 0;
             event.preventDefault();   
             if(store_lang == 'ja'){
               alert("商品はすでにカートに入っています。ダイヤモンドを変更してください。");      
             }else{
               alert("Product already in cart. Please change diamond.");      
             }
                   
           }                              
         });       
      }
    });
  
    var diamond = [{
        "diamond_id": $(this).data("diamondid"),
        "diamond_certno": $(this).data("certno"),
        "diamond_shape": $(this).data("shape"),
        "diamond_price": $(this).data("price"),
        "diamond_name": $(this).data("name"),
        "diamond_type": $(this).data("type"),
        "size" : $(this).data("carat"),
        "lab": $(this).data("lab"),
        "certificateNumber": $(this).data("certificatenumber"),
        "diamond_image": $(this).data("image"),
        "diamond_video": $(this).data("video"),
        "clarity": $(this).data("clarity"),
        "color": $(this).data("color"),
        "measurements": $(this).data("measurements"),
    }];

    setTimeout(function(){        
   
      if(proceedFlag == 1){   
        localStorage.setItem("ring_diamond", JSON.stringify(diamond));
        localStorage.setItem('disable_ring_add_to_cart' , 0);
        setSteps("diamond");
        $('#choose_diamond').removeClass('choose_diamond_spinner');
  
      }     
      
   }, 800);
  
  // window.location.href = "/collections/ring-builder-engagement-rings-1";
});
/****** end of choose diamond *****/

/******* Choose Setting function start ******/
$(document).on("click", ".choose-setting", function() {  
      
  $("#choose_setting").addClass("choose_setting_spinner");

  var selected_diamond = localStorage.getItem("ring_diamond");
  console.log(selected_diamond,"selected_diamond");

  const shapeMap = {"Round": "ラウンド", "Princess": "プリンセス", "Emerald": "エメラルド", "Asscher": "アッシャー", "Marquise": "マーキス", "Oval": "オーバル", "Baguette": "バゲット", "Pear": "ペア", "Heart": "ハート", "Cushion": "クッション", "Radiant": "ラディアント"};

  const ja_shape_array = {"ラウンド": "Round", "プリンセス": "Princess", "エメラルド": "Emerald", "アッシャー": "Asscher", "マーキス": "Marquise", "オーバル": "Oval", "バゲット": "Baguette", "ペア": "Pear", "ハート": "Heart", "クッション": "Cushion", "ラディアント": "Radiant"};

  if(selected_diamond != null || selected_diamond != undefined){
    var ring_selected_shape = $("#center_stone").val(); // English
    selected_diamond = JSON.parse(selected_diamond);
    var selected_shape = selected_diamond[0].diamond_shape; // Japanese (in ja locale)

    // Convert Japanese → English for comparison
    // var selected_shape_english = Object.keys(shapeMap).find(key => shapeMap[key] === selected_shape);
    // Convert Japanese → English ONLY if needed
    var selected_shape_english = selected_shape;

    // If it's not already English, convert it
    if (!shapeMap[selected_shape]) {
      selected_shape_english = Object.keys(shapeMap).find(
        key => shapeMap[key] === selected_shape
      ) || selected_shape;
    }

    console.log("ring_selected_shape (EN)", ring_selected_shape);
    console.log("selected_shape_english (EN)", selected_shape_english);

    if (selected_shape_english !== ring_selected_shape) {
        if (store_lang === 'ja') {
            alert("選択したダイヤモンドがリングに合わない場合は、ダイヤモンドを変更してください。");
        } else {
            alert("Selected diamond can not match with ring, please change the diamond");
        }

        $("#choose_setting").removeClass("choose_setting_spinner");
        return false;
    }

  }

  // Get current center stone (EN)
  var center_stone_val = $("#center_stone").val();

  // Convert to Japanese ONLY if store_lang is 'ja'
  if (store_lang === 'ja') {
    center_stone_val = shapeMap[center_stone_val] || center_stone_val;
  }

// // Convert can_be_match_with to array (English)
// var can_be_match_with = $("#can_be_match_with").val() || "";
// var allowed_shapes = can_be_match_with.split(",").map(s => s.trim());

// // Convert English → Japanese
// var allowed_shapes_ja = allowed_shapes.map(shape => ja_shape_array[shape] || shape);

  // Get value
  var can_be_match_with = $("#can_be_match_with").val() || "";

  // Convert to array
  var allowed_shapes = can_be_match_with.split(",").map(s => s.trim());

  // If Japanese store → convert EN → JA
  if (store_lang === 'ja') {
    allowed_shapes = allowed_shapes.map(shape => shapeMap[shape] || shape);
  }

  // Convert back to string
  var can_be_match_with_final = allowed_shapes.join(",");
  
    var setting = [{
        "product_id": $("#product_id").val(),
        "product_handel": $("#product_handel").val(),
        "setting_id": $("#variant_id").val(),
        "setting_name": $("#variant_name").val(), 
        "product_type": $("#variant_type").val(), 
        "setting_price": $("#variant_price").val(),
        "setting_metal_type": $("#setting_metal_type").val(),
        "setting_sku": $("#variant_sku").val(),
        "setting_url": $("#variant_url").val(),
      	// "setting_chainlength": $("#SingleOptionSelector-0").val(),
        "stock_num": $("#stock_num").val(),
        "minimum_carat_total_weight": $("#minimum_carat_total_weight").val().replace('ct','').trim(),
        "maximum_carat_total_weight": $("#maximum_carat_total_weight").val().replace('ct','').trim(),
        "setting_type": $("#setting_type").val(),
        "center_stone": center_stone_val,
        "can_be_match_with": can_be_match_with_final,
      	"image": $("#stockimg0").attr("src"),
      	"setting_style": $("#setting_style").val(),
        "setting_description":$("#product_description").val(),
        "setting_metafields":$("#product_metafields").val(),
        "setting_media_image_id":$("#varient_media_id").val(),
        "setting_image":$("#setting_image").val(),
    }];
    localStorage.setItem("ring_setting", JSON.stringify(setting));
    localStorage.setItem('disable_ring_add_to_cart' , 0);
    $("#choose_setting").removeClass("choose_setting_spinner");
    setSteps("setting");
});
/******* Choose Setting function end  ******/


/*** set currenct step and redirect to next step start ****/
function setSteps(current_step) {

    if (localStorage.getItem("ring_setting") && localStorage.getItem("ring_diamond")) {
        localStorage.setItem("ring_step3", "final pendant");
        var setting_info = JSON.parse(localStorage.getItem("ring_setting"));      
        var diamond_info = JSON.parse(localStorage.getItem("ring_diamond"));
        
      	var diamond_price = (diamond_info[0].diamond_price);      	    
        var final_price = parseInt(setting_info[0].setting_price/100) + diamond_price; 
        localStorage.setItem("final_ring_price", final_price);
        
        var diamond_id = diamond_info[0].diamond_id;
        var setting_id = setting_info[0].product_handel;
        var varient_id = setting_info[0].setting_id;
        var diamond_type = diamond_info[0].diamond_type;  
        window.location.href = tps_config.urls.ring_builder_final_page+"?setting_select=true&diamond_select=true?products="+diamond_id+"/"+setting_id+"/"+varient_id+"/"+diamond_type; // "/pages/final-pendant";

    } else if (current_step == "diamond" && localStorage.getItem("ring_setting")) {
        localStorage.setItem("ring_step2", "diamond");
        // $(".step").removeClass("current-active");
        //   $(".step2").addClass("current-active");
        //   $(".step2").addClass("active");
        window.location.href = tps_config.urls.ring_builder_final_page+"?setting_select=true&diamond_select=true" // "/pages/final-ring"; 
    } else if (current_step == "setting" && localStorage.getItem("ring_diamond")) {
        localStorage.setItem("ring_step2", "setting");
        window.location.href = tps_config.urls.ring_builder_final_page+"?setting_select=true&diamond_select=true" //"/pages/final-ring"; 
    } else if (current_step == "diamond" && !localStorage.getItem("ring_setting")) {
        localStorage.setItem("ring_step1", "diamond");
        localStorage.setItem("ring_step2", "setting");
        window.location.href = tps_config.urls.ring_builder_listing+"?setting_select=true";
    } else if (current_step == "setting" && !localStorage.getItem("ring_diamond")) {
      	localStorage.setItem("ring_step1", "setting");
        localStorage.setItem("ring_step2", "diamond");
        // $(".step").removeClass("current-active");
        //   $(".step1").addClass("current-active");
        //   $(".step1").addClass("active");
        window.location.href = tps_config.urls.ringbuilder_lab_diamond+"?diamond_select=true";
    }

}
// function setSteps(current_step) {

//   if (localStorage.getItem("ring_setting") && localStorage.getItem("ring_diamond")) {
//     localStorage.setItem("ring_step3", "final pendant");
//     var setting_info = JSON.parse(localStorage.getItem("ring_setting"));      
//     var diamond_info = JSON.parse(localStorage.getItem("ring_diamond"));
    
//     var diamond_price = (diamond_info[0].diamond_price);      	    
//     var final_price = parseInt(setting_info[0].setting_price / 100) + diamond_price; 
//     localStorage.setItem("final_ring_price", final_price);
    
//     var diamond_id = diamond_info[0].diamond_id;
//     var setting_id = setting_info[0].product_handel;
//     var varient_id = setting_info[0].setting_id;
//     var diamond_type = diamond_info[0].diamond_type;

//     // Fixed: use "&" instead of second "?"
//     window.location.href =
//       tps_config.urls.ring_builder_final_page +
//       "?setting_select=true&diamond_select=true&products=" +
//       diamond_id + "/" + setting_id + "/" + varient_id + "/" + diamond_type;

//   } else if (current_step == "diamond" && localStorage.getItem("ring_setting")) {
//     localStorage.setItem("ring_step2", "diamond");
//     window.location.href = tps_config.urls.ring_builder_final_page + "?setting_select=true&diamond_select=true";
//   } else if (current_step == "setting" && localStorage.getItem("ring_diamond")) {
//     localStorage.setItem("ring_step2", "setting");
//     window.location.href = tps_config.urls.ring_builder_final_page + "?setting_select=true&diamond_select=true";
//   } else if (current_step == "diamond" && !localStorage.getItem("ring_setting")) {
//     localStorage.setItem("ring_step1", "diamond");
//     localStorage.setItem("ring_step2", "setting");
//     window.location.href = tps_config.urls.ring_builder_listing + "?setting_select=true";
//   } else if (current_step == "setting" && !localStorage.getItem("ring_diamond")) {
//     localStorage.setItem("ring_step1", "setting");
//     localStorage.setItem("ring_step2", "diamond");
//     window.location.href = tps_config.urls.ringbuilder_lab_diamond + "?diamond_select=true";
//   }

// }
/*** set currenct step and redirect to next step end ****/


// $(document).ready(function() {
  
//   if((getQueryVariable('diamond_select') || getQueryVariable('setting_select') || getQueryVariable('id') || getQueryVariable('diamond_id') || window.location.pathname.indexOf('products') > -1  ) ){
   
//   }else{
//     if(localStorage.getItem("ring_setting") || localStorage.getItem("ring_diamond")){
//     	localStorage.removeItem("ring_diamond");
//         localStorage.removeItem("ring_setting");
//         localStorage.removeItem("final_ring_price");
//         localStorage.removeItem("ringbuilder_dia_shape");
//         localStorage.removeItem("ring_step1");
//         localStorage.removeItem("ring_step2");
//         localStorage.removeItem("ring_step3");
    
//       	window.location.href = tps_config.urls.ring_builder_listing;
//     }
   
//   }    
// });
$(document).ready(function() {

    var isInFlow = (
        getQueryVariable('diamond_select') == 'true' || 
        getQueryVariable('setting_select') == 'true' ||
        localStorage.getItem("ring_diamond") || 
        localStorage.getItem("ring_setting")
    );

    if (isInFlow) {
        // Update fancy diamond tab link
        $(".lab_fancy_link").each(function() {
            var base = $(this).attr("href").split("?")[0];
            $(this).attr("href", base + "?diamond_select=true");
        });

        // Update white/lab diamond tab link  
        $(".lab_white_link").each(function() {
            var base = $(this).attr("href").split("?")[0];
            $(this).attr("href", base + "?diamond_select=true");
        });
    }

});
/*** set currenct step and redirect to next step end ****/

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  } 
  return false;
}

 $(document).ready(function() {
      var currencyCode = "{{ cart.currency.iso_code }}";
      var currencySymbol = getCurrenySymbol(currencyCode);
   
      /*** set last updated timestamp of product collection if local storage has 1 hour old product collection then clear collection ****/
      if (localStorage.getItem("ring_last_updated")) {
          var d1 = new Date();
          var d2 = new Date(localStorage.getItem("ring_last_updated"));
          var diff = parseInt(((d1 - d2) / 1000).toString());
          if (diff > 3600) {
              localStorage.clear();
              localStorage.setItem("ring_last_updated", d1);
          }

      } else {
          localStorage.setItem("ring_last_updated", new Date());
      }

      /**** set steps and render steps data start *****/
      var active = '';
      var first_step = '';
      var second_step = '';
     if ((localStorage.getItem("ring_step1") == null && localStorage.getItem("ring_step2") == null)
    && (window.location.pathname.indexOf('/products/') >= 0 || window.location.pathname.indexOf('/collections/') >= 0)) {
          active = "setting";
          first_step = "setting";
        second_step = "diamond"; 
      //} else if ((localStorage.getItem("ring_step1") == null && localStorage.getItem("ring_step2") == null) && (window.location.pathname.indexOf('/pages/') == 0)) {
         // active = "diamond";
       //   first_step = "diamond";
     //     second_step = "setting";
        } else if ((localStorage.getItem("ring_step1") == null && localStorage.getItem("ring_step2") == null)) {

          // Only diamond-first when diamond_select=true is explicitly present
          if (getQueryVariable('diamond_select') == 'true') {
              active = "diamond";
              first_step = "diamond";
              second_step = "setting";
          }

      } else if ((localStorage.getItem("ring_step1") && (localStorage.getItem("ring_step1") == "diamond"))) {
          first_step = "diamond";
          second_step = "setting"; 
      } else if ((localStorage.getItem("ring_step1") && (localStorage.getItem("ring_step1") == "setting"))) {
          first_step = "setting";
          second_step = "diamond"; 
      }
      if (active == '') {
        if (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0) {
          active = "setting";
        } else if (window.location.pathname.indexOf('final-ring') > -1) {
          active = "final";         
        } else {
          active = "diamond";
        }

      }

      //dynamically steps text changes  
      if (first_step == "setting") {        
          if(jQuery(window).width() <= 767){
              //in mobile step text changes
              if(store_lang == 'ja'){
                $("#step1").html("セッティング");
                $("#step2").html("ダイヤモンド");
                $("#step3").html("コンプリート・リング");
              }else{
                $("#step1").html("Setting");
                $("#step2").html("Diamond");
                $("#step3").html("Complete Ring");
              }
              //end
          }else{
            if(store_lang == 'ja'){
              $("#step1").html("セッティング");          
              $("#step2").html("ダイヤモンド");
            }else{
              $("#step1").html("Choose Setting");          
              $("#step2").html("Choose Diamond");
            }
          }
          $(".step1").addClass("setting-step");
          $(".step2").addClass("diamond-step");
          $(".step_imgs1").addClass("ring_img");
          $(".step_imgs2").addClass("diamond_img");                   
          $(".step_imgs").removeClass("loading");
      } else {        
        if(jQuery(window).width() <= 767){
          //in mobile step text changes
          if(store_lang == 'ja'){
             $("#step2").html("セッティング");
             $("#step1").html("ダイヤモンド");
             $("#step3").html("最終ステップ");
          }else{
             $("#step2").html("Setting");
             $("#step1").html("Diamond");
             $("#step3").html("Complete Ring");
          }  
          //end
        }else{
          if(store_lang == 'ja'){
            $("#step2").html("セッティング");
            $("#step1").html("ダイヤモンド");
          }else{
            $("#step2").html("Choose Setting");
            $("#step1").html("Choose Diamond");
          }
        }
          
          $(".step1").addClass("diamond-step");
          $(".step2").addClass("setting-step");
          $(".step_imgs2").addClass("ring_img");
          $(".step_imgs1").addClass("diamond_img");
          $(".step_imgs").removeClass("loading");
      }
      //end
   
      if (first_step == "diamond" && localStorage.getItem("ring_diamond")) {
          var diamond_info = JSON.parse(localStorage.getItem("ring_diamond"));
        
        var currencyCode = "{{ cart.currency.iso_code }}";      
        var currency_rate = Shopify.currency.rate;
       	var dia_price = diamond_info[0].diamond_price;
        var dia_type = diamond_info[0].diamond_type;
        
           //steps product name,price, view & change urls
          $('#setting_name').html(diamond_info[0].diamond_name);
          $("#step1_price").html(''+Shopify.formatMoney(dia_price*100,theme.moneyFormat));
          $("#step1_view_href").attr("href", tps_config.urls.ringbuilder_loose_diamond_detail+"?diamond_id="+diamond_info[0].diamond_id+"&diamond_type="+dia_type);
          $('.tps-ringbuilder-product-image1').attr("src", diamond_info[0].diamond_image);
          $(".tps-product-click1").attr("href", tps_config.urls.ringbuilder_loose_diamond_detail+"?diamond_id="+diamond_info[0].diamond_id+"&diamond_type="+dia_type);
          // $('.tps-first-step-icon img').attr("src", diamond_info[0].diamond_image);
        
          if(dia_type == 'Lab Grown'){            
            $("#step1_change_href").attr("href", tps_config.urls.ringbuilder_lab_diamond+"?diamond_select=true");
          }else{
            $("#step1_change_href").attr("href", tps_config.urls.ringbuilder_lab_diamond+"?diamond_select=true");
          }
        
          // $(".step1_details").show();
        
          //change diamond tab url when diamond selected
          $("#diamond_type_wrap .white_select").attr("href", tps_config.urls.ringbuilder_lab_diamond+"?diamond_select=true");
          $("#diamond_type_wrap .lab_select").attr("href", tps_config.urls.ringbuilder_lab_diamond+"?diamond_select=true");
        
      } else if (second_step == "diamond" && localStorage.getItem("ring_diamond")) {  
          var diamond_info = JSON.parse(localStorage.getItem("ring_diamond"));    
          var dia_price = diamond_info[0].diamond_price;
          var dia_type = diamond_info[0].diamond_type;
        
          //steps product name,price, view & change urls
         $("#diamond_name").html(diamond_info[0].diamond_name+'');
         $("#step2_price").html(''+Shopify.formatMoney(dia_price*100,theme.moneyFormat));
         $("#step2_view_href").attr("href", tps_config.urls.ringbuilder_loose_diamond_detail+"?diamond_id=" + diamond_info[0].diamond_id+"&diamond_type="+dia_type);
         $(".tps-product-click2").attr("href", tps_config.urls.ringbuilder_loose_diamond_detail+"?diamond_id=" + diamond_info[0].diamond_id+"&diamond_type="+dia_type);
         $('.tps-ringbuilder-product-image2').attr("src", diamond_info[0].diamond_image);
        //  $('.tps-second-step-icon img').attr("src", diamond_info[0].diamond_image);
        
          if(dia_type == 'Lab Grown'){            
            $("#step2_change_href").attr("href", tps_config.urls.ringbuilder_lab_diamond+"?diamond_select=true");
          }else{            
            $("#step2_change_href").attr("href", tps_config.urls.ringbuilder_lab_diamond+"?diamond_select=true");
          }
        
          // $(".step2_details").show();
      }

      if (first_step == "setting" && localStorage.getItem("ring_setting")) {  
          var setting_info = JSON.parse(localStorage.getItem("ring_setting"));
          var setting_type = localStorage.getItem("ring_setting_type"); 
        
        //steps product name,price, view & change urls
         $('#setting_name').html(setting_info[0].setting_name);
         $("#step1_price").html(''+Shopify.formatMoney(setting_info[0].setting_price, theme.moneyFormat));
         $("#step1_view_href").attr("href", setting_info[0].setting_url);         
         $(".tps-product-click1").attr("href", setting_info[0].setting_url); 
         $("#step1_change_href").attr("href", tps_config.urls.ring_builder_listing+"?setting_select=true");
         $('.tps-ringbuilder-product-image1').attr("src", setting_info[0].setting_image);
         $(".step1_details").show();
         $('.tps-first-step-icon img').attr("src", setting_info[0].setting_image);

        //change diamond tab url when setting selected
          $("#diamond_type_wrap .white_select").attr("href", tps_config.urls.ringbuilder_loose_diamond+"?setting_select=true");
          $("#diamond_type_wrap .lab_select").attr("href", tps_config.urls.ringbuilder_lab_diamond+"?setting_select=true");
        
      } else if (second_step == "setting" && localStorage.getItem("ring_setting")) { 
          var setting_info = JSON.parse(localStorage.getItem("ring_setting"));
          var diamond_info = JSON.parse(localStorage.getItem("ring_diamond"));  
          
          $("#diamond_name").html(setting_info[0].setting_name+'');
          $("#step2_price").html(''+Shopify.formatMoney(setting_info[0].setting_price, theme.moneyFormat));
        //  $("#step2_price").html(''+currencySymbol+''+addCommas(setting_info[0].setting_price/100));
          $("#step2_view_href").attr("href", setting_info[0].setting_url);
          $(".tps-product-click2").attr("href", setting_info[0].setting_url);
          $("#step2_change_href").attr("href", tps_config.urls.ring_builder_listing+"?diamond_select=true");
          $(".step2_details").show();
          $('.tps-ringbuilder-product-image2').attr("src", setting_info[0].setting_image);
          $('.tps-second-step-icon img').attr("src", setting_info[0].setting_image);
      }
      /*** STEP STATE CONTROL - ACTIVE + CURRENT ACTIVE ***/
      
      // Remove all "current-active" before setting new one
      $(".step").removeClass("current-active");
      
      /*** STEP VISUAL STATE CONTROL ***/
      var firststep = localStorage.getItem("ring_step1");
      var secondstep = localStorage.getItem("ring_step2");
      var thirdstep = localStorage.getItem("ring_step3");

      // Handle step 1 completion and activation
      if (firststep == "setting" || firststep == "diamond") {
        $(".step1").addClass("active");
      }
      
      // Handle step 2 completion and activation  
      if (secondstep == "setting" || secondstep == "diamond") {
        $(".step1").addClass("active");
        $(".step2").addClass("active");
      }
      
      // Handle step 3 completion and activation
      if (thirdstep) {
        $(".step1, .step2, .step3").addClass("active");
      }
      
      // Set current-active based on current page/step
      if (thirdstep || window.location.pathname.indexOf('final-ring') > -1) {
        // Final step is current
        $(".step3").addClass("current-active");
      } else if (secondstep && !thirdstep) {
        // Second step is current
        $(".step2").addClass("current-active");
      } else if (firststep && !secondstep) {
        // First step completed, second step is current
        $(".step2").addClass("current-active");
      } else {
        // First step is current (default)
        $(".step1").addClass("current-active");
      }
      
      // Add active class to current step type
      $("." + active + "-step").addClass("active");

      if (window.location.pathname.indexOf('final-ring') > -1) {
        $(".diamond-step").addClass("active");
        $(".setting-step").addClass("active");
      }
      if (localStorage.getItem("final_ring_price")) { 
        var setting_info = JSON.parse(localStorage.getItem("ring_setting"));        
        var diamond_info = JSON.parse(localStorage.getItem("ring_diamond"));
        var final_title = setting_info[0].setting_name+' with '+diamond_info[0].diamond_name;
       
        $("#final_title").html(final_title);
        
         $("#step3_price").html(''+Shopify.formatMoney(localStorage.getItem("final_ring_price")*100, theme.moneyFormat));     
         //$("#step3_price").html(''+currencySymbol+''+addCommas(localStorage.getItem("final_ring_price")));        
      }
      if (localStorage.getItem("ring_diamond") && localStorage.getItem("ring_setting")) {
          var setting_info = JSON.parse(localStorage.getItem("ring_setting"));
          var diamond_info = JSON.parse(localStorage.getItem("ring_diamond"));    
          var diamond_id = diamond_info[0].diamond_id;
          var setting_id = setting_info[0].product_handel;
          var varient_id = setting_info[0].setting_id;
          $('.tps-ringbuilder-product-image3').attr("src", setting_info[0].setting_image);
          $('.tps-third-step-icon img').attr("src", setting_info[0].setting_image);
          var final_view_button_url = tps_config.urls.ring_builder_final_page+"?setting_select=true&diamond_select=true?products="+diamond_id+"/"+setting_id+"/"+varient_id; // "/pages/final-pendant";
          if(first_step == 'diamond'){
            $(".tps_reset_filter_diamond").show();
            $(".tps_reset_filter_setting").remove();
          }else{
            $(".tps_reset_filter_diamond").remove();
          }
        
          $("#step3_view_href").attr("href", final_view_button_url);        
          // $(".step3_details").show();
      }




  });
/**** set steps and render steps data end *****/

/**** ring builder flow start over start *****/
function startOver(step){
  localStorage.clear();
  
  if(step == 'setting'){
      window.location.href = tps_config.urls.ring_builder_listing+"";
  }else{
      window.location.href = tps_config.urls.ringbuilder_lab_diamond+"";
  }
}
/**** ring builder flow start over end *****/